import * as React from 'react';
import { Calendar, Divider, Drawer, Modal, Progress, Row } from 'antd';

import moment from 'moment';
import { L } from '../../../lib/abpUtility';

export interface ICalendarFormProps {
  visible: boolean;
  onCancel: () => void;
  primaryColor: string;
  secondaryColor: string;
  loading: boolean;
  isMobile: boolean;
}

export interface IreateOrUpdateCalendarFormState {
  loading: boolean;

}

class CalendarForm extends React.Component<ICalendarFormProps, IreateOrUpdateCalendarFormState> {

  state = {
    confirmDirty: false,
    fieldNameSize: '1.5em',
    loading: false,
    value: moment('2017-01-25'),
    selectedValue: moment('2017-01-25'),
    disabled: true,
    bounds: { left: 0, top: 0, bottom: 0, right: 0 },
  };



  render() {
    const { visible, onCancel } = this.props;

    return (

      <div>
        {this.props.isMobile === true ?
          <Drawer  width={window.innerWidth < 650 ? (window.innerWidth * 0.85) : 420}
            title={null}
            closeIcon={false} closable={this.props.isMobile === true ? true : false}
            footer={null} open={visible}
            onClose={onCancel}


          >
           <Divider className="font-face-gm" type="horizontal" style={{ fontSize: this.props.isMobile === true ? '2em' : '2.3em', marginBottom: '0px' }} >
              {L('Calendar')}
            </Divider>

            <Row>
              <Progress
                strokeColor={{
                  from: this.props.secondaryColor,
                  to: this.props.primaryColor,
                }}
                showInfo={false}
                percent={100}
                status="normal"
                size={'small'}
              />
            </Row>

            <Calendar />





          </Drawer>

          :
           <Modal
          closable={window.innerWidth < 650 === true ? true : false}
          cancelText={L('Cancel')}
          footer={null}
          open={visible}
          width={window.innerWidth < 650 === true ? (window.innerWidth * 0.85) : 600}
          onCancel={onCancel}
          title={null}>
          <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
            {L('Calendar')}
          </Divider>
          <Row style={{ marginBottom: '15px' }}>
            <Progress
              strokeColor={{
                from: this.props.secondaryColor,
                to: this.props.primaryColor,
              }}
              showInfo={false}
              percent={100}
              status="normal"
              size={'small'}
            />
          </Row>



          <Calendar />
         


        </Modal>
}

      </div>

    );
  }
}

export default CalendarForm;
